import auth from "@/store/auth/index";
import app from "@/store/app/index";
import user from "@/store/user/index";
import concierge from "@/store/concierge/index";
import admin from "@/store/admin/index";
import schedule from "@/store/schedule/index";

export default {
  app,
  auth,
  user,
  concierge,
  admin,
  schedule
};
